import gql from 'graphql-tag';

import { ATTACHMENT_LINK_METADATA_FRAGMENT } from './attachmentLinkMetadata';
import { GENERIC_LINK_METADATA_FRAGMENT } from './genericLinkMetadata';
import { GOOGLE_DOC_LINK_METADATA_FRAGMENT } from './googleDocLinkMetadata';
import { GOOGLE_DRIVE_FILE_LINK_METADATA_FRAGMENT } from './googleDriveFileLinkMetadata';
import { GOOGLE_SHEETS_LINK_METADATA_FRAGMENT } from './googleSheetsLinkMetadata';
import { GOOGLE_SLIDES_LINK_METADATA_FRAGMENT } from './googleSlidesLinkMetadata';
import { IMAGE_LINK_METADATA_FRAGMENT } from './imageLinkMetadata';
import { INVALID_LINK_METADATA_FRAGMENT } from './invalidLinkMetadata';
import { PLEX_FACT_LINK_METADATA_FRAGMENT } from './plexFactLinkMetadata';
import { PLEX_POST_LINK_METADATA_FRAGMENT } from './plexPostLinkMetadata';

export const LINK_PREVIEW_METADATA_DETAILS_FRAGMENT = gql`
  fragment linkPreviewMetadataDetails on LinkMetadataDetails {
    __typename
    ... on PlexPostLinkMetadata {
      ...plexPostLinkMetadata
    }
    ... on PlexFactLinkMetadata {
      ...plexFactLinkMetadata
    }
    ... on GoogleDocLinkMetadata {
      ...googleDocLinkMetadata
    }
    ... on GoogleDriveFileLinkMetadata {
      ...googleDriveFileLinkMetadata
    }
    ... on GoogleSheetsLinkMetadata {
      ...googleSheetsLinkMetadata
    }
    ... on GoogleSlidesLinkMetadata {
      ...googleSlidesLinkMetadata
    }
    ... on ImageLinkMetadata {
      ...imageLinkMetadata
    }
    ... on AttachmentLinkMetadata {
      ...attachmentLinkMetadata
    }
    ... on GenericLink {
      ...genericLinkMetadata
    }
    ... on InvalidLink {
      ...invalidLinkMetadata
    }
  }

  ${PLEX_POST_LINK_METADATA_FRAGMENT}
  ${PLEX_FACT_LINK_METADATA_FRAGMENT}
  ${IMAGE_LINK_METADATA_FRAGMENT}
  ${ATTACHMENT_LINK_METADATA_FRAGMENT}
  ${GENERIC_LINK_METADATA_FRAGMENT}
  ${INVALID_LINK_METADATA_FRAGMENT}
  ${GOOGLE_DOC_LINK_METADATA_FRAGMENT}
  ${GOOGLE_DRIVE_FILE_LINK_METADATA_FRAGMENT}
  ${GOOGLE_SHEETS_LINK_METADATA_FRAGMENT}
  ${GOOGLE_SLIDES_LINK_METADATA_FRAGMENT}
`;
